import { render, staticRenderFns } from "./SalProgressbar.vue?vue&type=template&id=5a0f615a&scoped=true"
import script from "./SalProgressbar.vue?vue&type=script&lang=js"
export * from "./SalProgressbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f615a",
  null
  
)

export default component.exports